import fr from 'facet-rest';

import CheckList from 'Components/UI/CheckList';
import MultiPicklistRadioGroup from 'Components/UI/Radio/MultiPicklistRadioGroup';
import SliderQuestion from 'Components/ClientApp/CombinedApp/Viewport/Flow/FlowStep/Questions/SliderQuestion';

// eslint-disable-next-line import/prefer-default-export
export const FlowStepQuestionOverride = fr.metaOverride()
  .override({
    type: 'multipicklist',
  }, {
    _component: () => CheckList,
    _customProps: {
      color: 'white',
    },
    _hideLabel: true,
  })
  .override({
    type: 'multipicklist',
    max: 1,
  }, {
    _component: () => MultiPicklistRadioGroup,
    _customProps: {
      color: 'white',
    },
    _hideLabel: true,
  })
  .override({
    type: 'multipicklist',
    hint: 'slider',
  }, {
    _hideLabel: true,
    _flowDescriptionBelowQuestion: true,
    _component: () => SliderQuestion,
    _customProps: {
      color: 'accentBlue',
    },
  });
